import assetPath from '/app/packages/lebenslauf/articles/src/assets/mit-stil-verzichten-vorstellungsgespraech-absagen.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')